export enum ConsolShipmentInvoiceType {
    SHIPPING_INVOICE = 15,
    SERVICE_INVOICE = 16,
    CONSOL_SHIPMENT_VAT_INVOICE = 17,
    PACKING_LIST = 18,
    SPECIFIC = 24,
}
